import React from 'react';

import styles from './styles.module.css';
import SpinnerIcon from '@/assets/spinner.svg?react';

interface ButtonProps {
  onClick?: () => void;
  label: string;
  disabled?: boolean;
  id?: string;
  customClass?: string;
  isLoading?: boolean;
  type?: 'button' | 'submit';
}

const Button: React.FC<ButtonProps> = ({
  onClick,
  label = '',
  disabled = false,
  id = '',
  customClass = '',
  isLoading = false,
  type = 'button'
}) => {
  return (
    <button
      id={id}
      type={type}
      className={`${styles.submitButton} ${customClass}`}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
      {isLoading && <SpinnerIcon className={styles.spinner} />}
    </button>
  );
};

export default Button;
